import React, { useEffect } from 'react';
import './PabloVirtualModal.css';

interface PabloVirtualModalProps {
  show: boolean;
  onClose: () => void;
  anchor?: { top: number; left: number };
}

const PabloVirtualModal: React.FC<PabloVirtualModalProps> = ({ show, onClose, anchor }) => {
  useEffect(() => {
    const handleKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    if (show) document.addEventListener('keydown', handleKey);
    return () => document.removeEventListener('keydown', handleKey);
  }, [show, onClose]);

  if (!show) return null;
  return (
    <div className="pv-modal-dialog-backdrop" style={anchor ? {alignItems: 'flex-start', justifyContent: 'flex-start'} : {}}>
      <div className="pv-modal-dialog-card" style={anchor ? {position: 'absolute', top: anchor.top, left: anchor.left, margin: 0} : {}}>
        <div className="pv-modal-content">
          <h2 className="pv-title">Bienvenid@ a Pablo Virtual!</h2>
          <p className="pv-desc">Desde ahora podés adquirirlo, e incluye la plataforma <b>Henua</b> sin cargo extra !</p>
          <p className="pv-small">Al hacer click te redirigiremos a <b>henua.net</b></p>
          <div className="pv-modal-actions">
            <a href="https://www.henua.net/humano-puente-pablovirtual" target="_blank" rel="noopener noreferrer" className="pv-btn">ir</a>
            <button className="pv-btn pv-btn-close" onClick={onClose}>Cerrar</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PabloVirtualModal;
